/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Not_OfferedInputs */

const id_reseller_pricing_not_offered = /** @type {(inputs: Reseller_Pricing_Not_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia`)
};

const en_reseller_pricing_not_offered = /** @type {(inputs: Reseller_Pricing_Not_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not offered`)
};

/**
* | output |
* | --- |
* | "Not offered" |
*
* @param {Reseller_Pricing_Not_OfferedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_not_offered = /** @type {((inputs?: Reseller_Pricing_Not_OfferedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Not_OfferedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_not_offered(inputs)
	return id_reseller_pricing_not_offered(inputs)
});